// extracted by mini-css-extract-plugin
export default {"about-container":"About_about-container__8S5x8","about":"About_about__vmvQk","about-section-container":"About_about-section-container__zLdQ7","about-text":"About_about-text__DvdX+"};